import React from "react";
import { types, Text, useAdminContext } from "react-bricks/frontend";
import styled from "styled-components";

interface ScrollToPointProps {
  id: string;
}

const ScrollToPoint: types.Brick<ScrollToPointProps> = ({ id }) => {
  const { isAdmin } = useAdminContext();
  return (
    <div id={id}>
      {isAdmin && (
        <Wrapper>
          This is a hidden anchor-point, it won't be shown outside of this editor.
          <br />
          Use "#{id}" as a button link to smooth scroll to this point in the page.
        </Wrapper>
      )}
    </div>
  );
};

ScrollToPoint.schema = {
  // Unique brick name
  name: "scrolltopoint",
  label: "ScrollToPoint",

  // Defaults when a new brick is added
  getDefaultProps: () => ({
    id: `anchor-${+new Date()}`,
  }),

  // Sidebar Edit controls for props
  sideEditProps: [
    {
      name: "id",
      label: "ID",
      type: types.SideEditPropType.Text,
    },
  ],
};

export default ScrollToPoint;

const Wrapper = styled.div`
  text-align: center;
  font-size: 0.8rem;
  border-top: 1px solid gray;
  border-bottom: 1px solid gray;
`;
